"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getMetadataFromSlotComponent", {
    enumerable: true,
    get: function() {
        return getMetadataFromSlotComponent;
    }
});
const _reactutilities = require("@fluentui/react-utilities");
function getMetadataFromSlotComponent(type) {
    const { as, [_reactutilities.SLOT_CLASS_NAME_PROP_SYMBOL]: _classNameProp, [_reactutilities.SLOT_ELEMENT_TYPE_SYMBOL]: baseElementType, [_reactutilities.SLOT_RENDER_FUNCTION_SYMBOL]: renderFunction, ...propsWithoutMetadata } = type;
    const props = propsWithoutMetadata;
    const elementType = typeof baseElementType === 'string' ? as !== null && as !== void 0 ? as : baseElementType : baseElementType;
    if (typeof elementType !== 'string' && as) {
        props.as = as;
    }
    return {
        elementType,
        props,
        renderFunction
    };
}
